// Client-only admin components (Next.js App Router compatible)
// These components use API calls instead of direct server imports

export { DocumentUploaderClient as DocumentUploader } from "./client/document-uploader-client";
export { KnowledgeManagementClient as KnowledgeManagement } from "./client/knowledge-management-client";
export { RAGManagerClient as RAGManager } from "./client/rag-manager-client";
export { KnowledgeEditorClient as KnowledgeEditor } from "./client/knowledge-editor-client";
export { default as NotificationCenter } from "./NotificationCenter";
export { RSSManager } from "../chatbot/rss-manager";
